import Navigo from 'navigo';
import {sensorDetails} from "./sensor";
import {config, loadSensors} from "./config";
import {getAsync} from "./utils";
import {
  displayWindMeasures,
  displayWaveMeasures,
  initMeasuresLayer,
  tideDetails,
  webcamDetails,
  initSensorsPolling, addLayer
} from "./data";
import {closePoi, setPoiButton, weatherDetails} from "./meteogramme";
import {displayWindFranceForm, displayNews, layers, layout, logPageView, map, updateLayout} from "./common";
import {initTimeline} from "./timeline";
import {clearBgLayers, clearDataLayers, displayCoastLine, initMap, setPopupContent, toggleMap} from "./map";
import {displayEditControls, getUserSpot, selectPinnedElements, signInUser} from "./account";
import * as L from "leaflet/dist/leaflet";

const router = new Navigo("/");
let autoRefresh;

// console.time('routerConfig');

router.on("/", function(match) {
  // console.timeEnd('partialInit');
  layers.activeSpot = null;
  displayDefaultData(null);
  logPageView(router.lastResolved(), '/', 'Accueil');
  setAutoRefresh();
});

router.on("/webcam/:name", function (match) {
  layers.activeSpot = null;
  displayDefaultData(function() {
    getAsync(config.backEndUrl + '/webcams/list.json', function (data) {
      const webcam = data.webcams.find(element => element.slug === match.data.name);
      if (webcam) {
        webcamDetails(null, webcam, () => { router.navigate("/"); });
        logPageView(router.lastResolved(),'/webcam/' + webcam.slug, webcam.label);
      }
    });
  });
});

router.on("/port/:name", function (match) {
  layers.activeSpot = null;
  displayDefaultData(function() {
    getAsync(config.backEndUrl + '/harbors/list.json', function (data) {
      const harbor = data.harbors.find(element => element.slug === match.data.name);
      if (harbor) {
        tideDetails(null, harbor, () => { router.navigate("/"); });
        logPageView(router.lastResolved(),'/port/' + harbor.slug, harbor.label);
      }
    });
  });
});

router.on("/previsions/:name", function (match) {
  layers.activeSpot = null;
  displayDefaultData(function() {
    getAsync(config.backEndUrl + "/live_forecasts/weather.json", function (poisData) {
      const poi = poisData["pois"].find(element => element.slug === match.data.name);
      if (poi) {
        weatherDetails(null, poi);
        const menuBtn = document.querySelector("#weather_fc");
        if (menuBtn.classList.contains("active") && layers.dataLayers.indexOf('weather_fc') !== -1) {
          setPoiButton(poi.slug);
        }
        map.instance.setView(new L.LatLng(parseFloat(poi.lat) - 0.1, parseFloat(poi.lng)), 9.5);
        logPageView(router.lastResolved(),'/previsions/' + poi.slug, poi.label);
        setAutoRefresh();
      }
    });
  });
});

router.on("/profil/:account/spots/:spot", function (match) {
  const spotRef = match.data.spot, editMode = match.params?.edit;
  const userSpot = getUserSpot(spotRef), isEdit = editMode === 'true';
  userSpot.edit = isEdit;
  layout.edit = isEdit;
  if (!isEdit) {
    layers.activeSpot = userSpot;
  } else {
    layers.activeSpot = null;
  }
  console.debug('userSpot: ' + JSON.stringify(userSpot));

  displayDefaultData(function() {
    console.debug(`setView : ${userSpot.mapCenter[0]}, ${userSpot.mapCenter[1]}`);
    map.instance.setView(new L.LatLng(userSpot.mapCenter[0], userSpot.mapCenter[1]), userSpot.mapZoom);
    if (userSpot.pois.length) {
      getAsync(config.backEndUrl + "/live_forecasts/weather.json", function (poisData) {
        const poi = poisData["pois"].find(element => element.slug === userSpot.pois[0]);
        if (poi) {
          weatherDetails(null, poi);
        }
      });
    }
    if (userSpot.point) {
      setTimeout(function() {
        const coords = L.latLng(userSpot.point[0], userSpot.point[1]);
        map.popup = L.popup().setLatLng(coords);
        config.popup = map.popup;
        setPopupContent(config.popup, {latlng: coords});
        config.popup.openOn(map.instance)
      }, 1000);
    } else if (map.popup) {
      map.popup.remove();
      map.popup = null;
    }

    if (userSpot.edit) {
      displayEditControls(spotRef);
      setTimeout(function() {
        selectPinnedElements(userSpot);
      }, 1500);
    } else {
      document.querySelector("#edit_spot_controls").classList.add('hidden');
    }

    logPageView(router.lastResolved(), `/spots/${spotRef}`, `Spot ${spotRef}`);
    setAutoRefresh();
  }, userSpot);
});

router.on("/:name", function (match) {
  layers.activeSpot = null;
  displayDefaultData(function () {
    loadSensors(function (data) {
      let sensors = Object.values(data.sensors['WindSensor'] || {}).concat(Object.values(data.sensors['WaveSensor'] || {}))
        .concat(Object.values(data.sensors['TempSensor'] || {}));
      let sensor = sensors.find(s => s.slug === match.data.name);
      if (sensor) {
        sensorDetails(null, sensor, () => { router.navigate("/"); });
        logPageView(router.lastResolved(), '/' + sensor.slug, sensor.label);
        setAutoRefresh();
      }
    });
  });
});

if (localStorage.getItem('windUser')) {
  signInUser();
  router.resolve();
} else {
  // if (config.favoritePath && window.location.pathname === '/') {
  //   if(document.querySelector("#map_favorite button").classList.contains("no-favorite")){
  //     document.querySelector("#map_favorite button").classList.remove("no-favorite")
  //   }
  //   router.navigate(config.favoritePath);
  // } else {
  //   if(!document.querySelector("#map_favorite button").classList.contains("no-favorite")){
  //     document.querySelector("#map_favorite button").classList.add("no-favorite")
  //   }
  //   router.resolve();
  // }
  router.resolve();

  if (window.location.search.indexOf('nosplash') === -1) {
    displayWindFranceForm(1000);
  }
}

function displayDefaultData(callback, customConfig = {}) {
  let isHome = router.lastResolved() === null || router.lastResolved().path === '';
  console.debug('displayDefaultData - customConfig ' + JSON.stringify(customConfig));
  if (isHome || (customConfig && JSON.stringify(customConfig) !== '{}')) {
    updateLayout();

    const referenceDate = new Date(new Date().toDateString()).getTime() / 1000;
    initMap(customConfig);
    try {
      loadSensors(function () {
        initMeasuresLayer();

        const mapContainer = document.querySelector("#map_container"),
          sideLayers = document.querySelectorAll("#layers_tab button"),
          mapLayers = document.querySelectorAll("#map_layers button");

        clearBgLayers();
        clearDataLayers();

        if (map.popup) {
          map.popup.close();
          map.popup = null;
        }
        map.activeMap = null;
        for (const btn of sideLayers) {
          btn.classList.remove('active');
        }
        for (const btn of mapLayers) {
          btn.classList.remove('active');
        }
        if (document.body.classList.contains('active_poi')) {
          closePoi();
        }

        const bgLayers = customConfig.bgLayers || ['wm'];
        const dataLayers = customConfig.dataLayers || ['wind', 'waves'];

        for (const l of bgLayers) {
          toggleMap(document.querySelector(`.map_layer[onclick*='${l}']`), l);
        }

        for (const l of dataLayers) {
          addLayer(l);
          layers.dataLayers.push(l);
          mapContainer.classList.add(l);
          document.querySelector(`#layers_tab #${l}_side`)?.classList?.add('active');
          document.querySelector(`#map_layers #${l}`)?.classList?.add('active');
        }

        if (callback) {
          callback();
        }
      });
    } catch (e) {
      console.error("default init error: " + e);
    }
    initTimeline(referenceDate);
    initSensorsPolling();
  } else {
    try {
      displayWindMeasures();
      displayWaveMeasures();
      // displayWaterTemp();
      if (callback) {
        callback();
      }
    } catch (e) {
      console.error("default init error: " + e);
    }
  }
}

function setAutoRefresh() {
  // if (autoRefresh) {
  //   clearTimeout(autoRefresh);
  // }
  // autoRefresh = setTimeout(function() {
  //   window.location.reload();
  // }, 900000);
}

// console.timeEnd('routerConfig');

export default router;
